<!--
 * @Description: 常见问题
-->
<template>
    <div class="must-know">
        <van-nav-bar
                left-text="返回"
                :title="title"
                @click-left="$comm.onClickLeft"
                v-show="$comm.titleShow()"  left-arrow
                fixed>
            <template #left>
                <span class="iconfont iconshang comm-rotate-270"></span>
                <span class="comm-return">返回</span>
            </template>
        </van-nav-bar>
        <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
        <van-tabs color="#1677FF" v-model="active" @change="onChange" sticky>
            <van-tab v-for="(tab, i) in tabs" :key="i" :title="tab.title">
                <div class="comm-seperator"></div>
                <div class="must-know-list">
                    <div v-for="(article, j) in articleList" :key="j">
                        <must-know-item :article="article" :title="tab.title"></must-know-item>
                    </div>
                </div>
                <div v-if="!loading&&articleList.length===0" style="text-align:center;">
                    <img style="width:200px;" :src="require('../../assets/images/no-data.png')">
                </div>
            </van-tab>
        </van-tabs>
        <div style="height:57px"></div>
        <home-bar></home-bar>
    </div>
</template>

<script>
    import MustKnowItem from '../guide/MustKnowItem'
    import HomeBar from '@/components/HomeBar.vue'
    export default {
        name: 'xinwen',
        components: {
            MustKnowItem,
            HomeBar
        },
        data() {
            return {
                active: 0,
                tabs: [
                    {
                        title: '公司新闻'
                    },
                    {
                        title: '政策法规'
                    }
                ],
                payWayContent: '',
                typeCode: 106,
                articleList: [],
                loading: false,
                article:{
                    ftitle:'',
                    fissuedate:'',
                    fhits:'',
                    fcontent:''
                },
                title:''
            }
        },
        mounted() {
            if (this.$route.query.active) {
                this.active = Number(this.$route.query.active)
            }
            this.onChange(this.active)
        },
        methods: {
            onChange(value) {
                if (value === 0) {
                    this.typeCode = 106 // 公司新闻
                    this.title = '公司新闻'
                } else if (value === 1) {
                    this.typeCode = 120 // 政策法规
                    this.title = '政策法规'
                } 
                this.getArticleData()
            },
            getArticleData() {
                let params = {
                    "typecode": this.typeCode,
                    "pagesize": 20,
                    "pageindex": 1
                }
                this.articleList = []
                this.$loading()
                this.loading = true
                this.$http.post(this.$api.getArticles, params).then(res => {
                    this.$clear()
                    this.loading = false
                    if (res.code === '000') {
                        this.articleList = res.data
                    } else {
                        this.$toast(res.msg)
                    }
                })
            },
        },
    }
</script>

<style lang="less" scoped>
    .must-know {
        .sales-net-list {
            padding: 0 16px;
        }
    }
</style>